import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import { errorMessage } from 'helpers/common';
import * as Sentry from "@sentry/react";

const fetchStateEmployeeSettings = createAsyncThunk('fetchStateEmployeeSettings', async (_, { getState, rejectWithValue }) => {
  try {
    const { data, status } = await api.get('/settings/state-employee');
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch state employee settings'));
  }
});

const fetchStateEmployeeFields = createAsyncThunk('fetchStateEmployeeFields', async (_, { getState, rejectWithValue }) => {
  try {
    // const { data, status } = await api.get('/settings/fields/state-employee');
    const { data, status } = await api.get('/forms/state_employee_form/definition');
    if (status === 200) return data;
  } catch (err) {
    if (err.response?.status !== 404) {
      Sentry.captureException(err);
    }
    return rejectWithValue(errorMessage(err, 'fetch state employee fields'));
  }
});

export const stateEmployeeSlice = createSlice({
  name: 'stateEmployee',
  initialState: {
    settings: null,
    fields: null,
    sections: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStateEmployeeFields.fulfilled, (state, action) => {
        // state.fields = action.payload.data;
        state.sections = action.payload.sections;
      })
      .addCase(fetchStateEmployeeSettings.fulfilled, (state, action) => {
        const obj = {};
        for (const item of action.payload.data) {
          obj[item.key] = item.value;
        }
        state.settings = obj;
      });
  }
});

export const getStateEmployeeSettings = (state) => state.stateEmployee.settings;
export const getStateEmployeeFields = (state) => state.stateEmployee.fields;
export const getStateEmployeeSections = (state) => state.stateEmployee.sections;

export { fetchStateEmployeeFields, fetchStateEmployeeSettings };

export default stateEmployeeSlice.reducer;
